var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "dashboard-page-title" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("h1", [_vm._v("Booking Import")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "spacer-b-2 w-25" },
          [
            _c("label", { attrs: { for: "type" } }, [
              _vm._v("Select an import type"),
            ]),
            _vm._v(" "),
            _c("selectize", {
              staticClass: "selectize selectize-single",
              attrs: {
                id: "type",
                name: "type",
                placeholder: "Import Type",
                options: _vm.typeOptions,
              },
              model: {
                value: _vm.type,
                callback: function ($$v) {
                  _vm.type = $$v
                },
                expression: "type",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("p", [
          _c(
            "a",
            {
              attrs: { href: "#", target: "_blank" },
              on: { click: _vm.downloadExample },
            },
            [_vm._v("Download an example file")]
          ),
        ]),
        _vm._v(" "),
        _vm._m(0),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "dashboard-block" }, [
        _c("form", [
          _c(
            "div",
            {
              staticClass: "panel panel-grey",
              class: { "is-droppable": _vm.dropable },
            },
            [
              _c("div", { staticClass: "panel-body" }, [
                _c("div", { staticClass: "form-horizontal" }, [
                  _c("div", { staticClass: "row" }, [
                    _vm.isFailed
                      ? _c("div", { staticClass: "col-md-12" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: { type: "button" },
                              on: { click: _vm.reset },
                            },
                            [_vm._v("Retry")]
                          ),
                        ])
                      : _vm.isSuccess
                      ? _c("div", { staticClass: "col-md-12 text-center" }, [
                          _c(
                            "h3",
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("sentenceCase")(_vm.selectedLabel)
                                ) +
                                  " file uploaded. New bookings will be reviewed and added to your\n                    "
                              ),
                              _c(
                                "router-link",
                                { attrs: { to: "/" + _vm.selectedLink } },
                                [_vm._v("list")]
                              ),
                              _vm._v(".\n                  "),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: { type: "button" },
                              on: { click: _vm.reset },
                            },
                            [_vm._v("Upload another file")]
                          ),
                        ])
                      : _c("div", { staticClass: "col-md-12" }, [
                          _c(
                            "div",
                            {
                              staticClass: "dropbox",
                              on: {
                                drop: _vm.fileDropped,
                                dragenter: function ($event) {
                                  _vm.dropable = true
                                },
                                dragleave: function ($event) {
                                  _vm.dropable = false
                                },
                              },
                            },
                            [
                              !_vm.isSaving
                                ? _c("input", {
                                    staticClass: "form-control input-file",
                                    attrs: {
                                      name: "uploadFile",
                                      disabled: _vm.isSaving,
                                      type: "file",
                                      accept: "text/csv",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.setFiles($event.target.files)
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("help-block", { attrs: { field: "file" } }),
                              _vm._v(" "),
                              _vm.isSuccess
                                ? _c("p", [
                                    _vm._v(
                                      "\n                      File Uploaded\n                    "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isInitial
                                ? _c("p", [
                                    _vm._v(
                                      "\n                      Click to browse "
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                      Drag your file(s) here\n                    "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isSaving
                                ? _c("p", [
                                    _vm._v(
                                      "\n                      Uploading files...\n                    "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isFailed
                                ? _c("p", [
                                    _vm._v(
                                      "\n                      Failed to import\n                    "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              this.uploadFile
                                ? _c("span", [
                                    _vm._v(
                                      "Upload File: " +
                                        _vm._s(this.uploadFile.name)
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("validate-input", {
                          attrs: {
                            "file-error": _vm.fileError,
                            "importer-errors": _vm.importerErrors,
                            "importer-warnings": [],
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "dashboard-page-title" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            attrs: { type: "button", id: "formSubmit", name: "formSubmit" },
            on: { click: _vm.uploadFiles },
          },
          [_vm._v("Start upload")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("Expected date format : YYYY-MM-DD (e.g. 1990-12-31)"),
      _c("br"),
      _vm._v(
        "\n        Expected value separator inside a cell : | (e.g. john@test.com|doe@test.com)"
      ),
      _c("br"),
      _vm._v("\n        Expected opportunity reference format: 199 | 200"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }